import View from './View';

import icons from 'url:../../img/icons.svg';
import { Fraction } from 'fraction.js';
// import { fracty } from 'fracty';
import { mark } from 'regenerator-runtime';
// this view is a class since there will be a "View" parent class that will contain methods that all views have to inherit.  Using classes makes it easy to implement. Also, classes makes it easy to implement private methods and properties, so classes make it easy to do.
class RecipeView extends View {
  // private methods
  // #parentElement is private, and it's set to the recipe container.  It makes it easy to render the spinner, success/error messages, and (of course) the recipe itself!
  _parentElement = document.querySelector('.recipe');
  _errorMessage = 'No recipes found.';
  _message = '';

  // publisher/subscriber pattern.  addHandlerRender is the publisher listening for the event.  It receives the handler function (a controller that lives in the controller).  Then, we can listen for it in the view while handle it in the controller.  It will reside in paginationView.js
  addHandlerRender(handler) {
    // eventListener is the event, and controlRecipes is the handler function.  In the first iteration, it's 'hashchange'.  In the second, it is 'load'.  It's the same as doing this:
    /*  
window.addEventListener('hashchange', controlRecipes);
window.addEventListener('load', controlRecipes);
*/
    ['hashchange', 'load'].forEach(eventListener =>
      window.addEventListener(eventListener, handler)
    );
  }

  addHandlerUpdateServings(handler) {
    this._parentElement.addEventListener('click', function (e) {
      const btn = e.target.closest('.btn--update-servings');
      if (!btn) return;
      const { updateTo } = btn.dataset;
      // convert it to a number with +
      if (+updateTo > 0) handler(+updateTo);
    });
  }

  addHandlerAddBookmark(handler) {
    this._parentElement.addEventListener('click', function (e) {
      // just in case the user clicks on the icon element instead of the button.
      const btn = e.target.closest('.btn--bookmark');
      // a guard clause
      if (!btn) return;
      handler();
    });
  }

  _generateMarkup() {
    return `
      <figure class="recipe__fig">
        <img src="${this._data.image}" alt="${
      this._data.title
    }" class="recipe__img" />
        <h1 class="recipe__title">
          <span>${this._data.title}</span>
        </h1>
      </figure>

      <div class="recipe__details">
        <div class="recipe__info">
          <svg class="recipe__info-icon">
            <use href="${icons}#icon-clock"></use>
          </svg>
          <span class="recipe__info-data recipe__info-data--minutes">${
            this._data.cookingTime
          }</span>
          <span class="recipe__info-text">minutes</span>
        </div>
        <div class="recipe__info">
          <svg class="recipe__info-icon">
            <use href="${icons}#icon-users"></use>
          </svg>
          <span class="recipe__info-data recipe__info-data--people">${
            this._data.servings
          }</span>
          <span class="recipe__info-text">servings</span>

          <div class="recipe__info-buttons">
            <button class="btn--tiny btn--update-servings" data-update-to="${
              this._data.servings - 1
            }">
              <svg>
                <use href="${icons}#icon-minus-circle"></use>
              </svg>
            </button>
            <button class="btn--tiny btn--update-servings" data-update-to="${
              this._data.servings + 1
            }">
              <svg>
                <use href="${icons}#icon-plus-circle"></use>
              </svg>
            </button>
          </div>
        </div>

        <div class="recipe__user-generated ${this._data.key ? '' : 'hidden'}">
          <svg>
            <use href="${icons}#icon-user"></use>
          </svg>
        </div>
        <button class="btn--round btn--bookmark">
          <svg class="">
            <use href="${icons}#icon-bookmark${
      this._data.bookmarked ? '-fill' : ''
    }"></use>
          </svg>
        </button>
      </div>

      <div class="recipe__ingredients">
        <h2 class="heading--2">Recipe ingredients</h2>
        <ul class="recipe__ingredient-list">
          ${this._data.ingredients.map(this._generateMarkupIngredient).join('')}
      </div>

      <div class="recipe__directions">
        <h2 class="heading--2">How to cook it</h2>
        <p class="recipe__directions-text">
          This recipe was carefully designed and tested by
          <span class="recipe__publisher">${
            this._data.publisher
          }</span>. Please check out
          directions at their website.
        </p>
        <a
          class="btn--small recipe__btn"
          href="${this._data.sourceUrl}"
          target="_blank"
        >
          <span>Directions</span>
          <svg class="search__icon">
            <use href="${icons}#icon-arrow-right"></use>
          </svg>
        </a>
      </div>
    `;
  }

  // this will receive the ingredient
  _generateMarkupIngredient(ingredient) {
    return `
      <li class="recipe__ingredient">
      <svg class="recipe__icon">
        <use href="${icons}#icon-check"></use>
      </svg>
      <div class="recipe__quantity">${
        ingredient.quantity ? new Fraction(ingredient.quantity).toString() : ''
      }</div>
      <div class="recipe__description">
        <span class="recipe__unit">${ingredient.unit}</span>
        ${ingredient.description}
      </div>
    </li>
      `;
  }
}
// needs to be exported so the controller can use it.  It's too much work on the controller to export the ENTIRE class, then in the controller, we'd have to import it AND create a new object out of it (create a new RecipeView object.  However, you may be creating more than one view.  It also makes it more difficult on the controller (Keep it simple).  // To avoid it, create the object here and then export it, so no one from the outside of the class can access it except for the object.  Don't pass any data in, so no need for a constructor
export default new RecipeView();
